import request from '@/utils/request'

// 获取大事记列表（分页）
export function getGreatEvents(query) {
  return request({
    url: '/api/great-events',
    method: 'get',
    params: query
  })
}

// 获取首页显示的大事记列表
export function getVisibleGreatEvents(limit = 10) {
  return request({
    url: '/api/great-events/visible',
    method: 'get',
    params: { limit }
  })
}

// 获取单条大事记详情
export function getGreatEvent(eventId) {
  return request({
    url: `/api/great-events/${eventId}`,
    method: 'get'
  })
}

// 添加大事记
export function addGreatEvent(data) {
  return request({
    url: '/api/great-events',
    method: 'post',
    data
  })
}

// 更新大事记
export function updateGreatEvent(eventId, data) {
  return request({
    url: `/api/great-events/${eventId}`,
    method: 'put',
    data
  })
}

// 删除大事记
export function deleteGreatEvent(eventId) {
  return request({
    url: `/api/great-events/${eventId}`,
    method: 'delete'
  })
} 